export function htmlDecode(input?: string): string {
  if (!input) {
    return '';
  }

  const doc = new DOMParser().parseFromString(input, 'text/html');
  return doc.documentElement.textContent ?? input;
}